import * as XLSX from "xlsx";
import Papa, { ParseResult } from "papaparse";
import { toastr } from "react-redux-toastr";

const CSV_FILE_TYPES = [
  "text/comma-separated-values",
  "text/csv",
  "application/csv",
  "application/vnd.ms-excel",
  "application/vnd.msexcel",
  "csv",
];

const EXCEL_FILE_TYPES = [
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  "xlsx",
];

export const dibels_columns = {
    "LNF": ["LNF (LNF)", "LNF"],
    "NWF-CLS": [
        "NWF-CLS (NWF-CLS)",
        "NWF - CLS(NWF - CLS)",
        "NWF - CLS (NWF - CLS)",
        "NWF (CLS)",
        "NWF (NWF-CLS)",
        "NWF: CLS",
        "NWF - CLS",
        "NWF-CLS"
    ],
    "NWF-WRC": [
        "NWF-WRC (NWF-WRC)",
        "NWF - WRC (NWF-WRC)",
        "NWF - WRC (NWF - WRC)",
        "NWF (NWF-WRC)",
        "NWF (WRC)",
        "NWF: WRC",
        "NWF - WRC",
        "NWF-WRC"
    ],
    "ORF-Accuracy": [
        "ORF-ACC (ORF-ACC)",
        "ORF (Percent)",
        "ORF (Accuracy)",
        "ORF - Accuracy(ORF - Accuracy)",
        "ORF - Accuracy (ORF - Accuracy)",
        "ORF-Accuracy(ORF-Accuracy)",
        "ORF(ORF - Accuracy)",
        "ORF (ORF - Accuracy)",
        "ORF(ORF-Accuracy)",
        "ORF (ORF- Accuracy)",
        "ORF (ORF -Accuracy)",
        "ORF - Accuracy (ORF - Accuracy)"
    ],
    "ORF-WordsCorrect": [
        "ORF (ORF)",
        "ORF (ORF-Words Correct)",
        "ORF (ORF - Words Correct)",
        "ORF (Words Correct)",
        "ORF (ORF Words Correct)",
        "ORF - Words Correct (ORF - Words Correct)",
        "ORF-Words Correct (ORF-Words Correct)"
    ],
    "PSF": ["PSF (PSF)", "PSF"],
    "WRF": ["WRF (WRF)", "WRF"],
    "Maze-Adjusted": [
        "MAZE",
        "Maze (Maze Adjusted)",
        "MAZE (Maze Adjusted)",
        "Maze (MAZE Adjusted)",
        "MAZE (MAZE Adjusted)",
        "Maze",
        "Maze-Adj",
        "MAZE - Adj",
        "Adj",
        "Maze (Maze)",
        "Maze(Maze)",
        "Maze Adjusted",
        "Maze Adjusted (Maze Adjusted)",
        "Maze Adjusted(Maze Adjusted)"
    ],
    "Composite": [
        "Composite-Score",
        "Composite",
        "Composite - Score",
        "Composite Score"
    ]
}

export const parseCsvFile = ({
  file,
  onComplete,
  onShowError,
}: {
  file: File;
  onComplete: (results: ParseResult, file?: File) => void;
  onShowError: Function;
}) => {
  const fileType = file
    ? file.type
      ? file.type
      : file.name.slice(((file.name.lastIndexOf(".") - 1) >>> 0) + 2)
    : "";

  const reader = new FileReader();
  const readAsArrayBuffer = EXCEL_FILE_TYPES.includes(fileType);

  reader.onload = (e) => {
    if (reader.result) {
      if (CSV_FILE_TYPES.includes(fileType)) {
        handleCSVData(reader.result as string, fileType, onComplete);
      } else if (EXCEL_FILE_TYPES.includes(fileType)) {
        const workbook = XLSX.read(reader.result, { type: "array" });
        const sheet = workbook.Sheets[workbook.SheetNames[0]];

        const asCSV = XLSX.utils.sheet_to_csv(sheet);
        handleCSVData(asCSV, "csv", onComplete);
      } else {
        onShowError();
      }
    } else {
      onShowError();
    }
  };

  if (readAsArrayBuffer) {
    reader.readAsArrayBuffer(file);
  } else {
    reader.readAsText(file);
  }
};

export const handleCSVData = (
  csvData: string,
  fileType: string,
  onComplete?: (results: ParseResult, file?: File) => void
) => {
  Papa.parse(csvData, {
    complete: onComplete,
    header: true,
    dynamicTyping: true,
    trimHeaders: true,
    skipEmptyLines: true,
    transform(value: string, field: string | number): any {
      return value.trim();
    },
    transformHeader(header: string): any {
      return header.trim();
    },
  });
};

export const vaildFileExtension = (file: File) => {
  if(file) {
    const fileStringCount = file.name.split('.').length;
    if(fileStringCount == 1) {
      toastr.error('Alert', "Invalid file type.");
      return;
    } else if(fileStringCount > 2) {
      toastr.error('Alert', "File with double extension not allowed.");
      return;
    }
    return true;
  }
}
